import "./css/Footer.css";

import { FaFacebookF } from "react-icons/fa";
import { FaTwitter } from "react-icons/fa";
import { RiInstagramFill } from "react-icons/ri";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer className="landing-footer">
      <div className="footer-container landing-container">
        <h1>
          Physio<span>Track</span>
        </h1>
        <div className="footer-contents">
          <div className="left">
            <h3>Socials</h3>
            <p>Get in touch with us through social platforms.</p>
            <nav className="social-links">
              <a href="www.facebook.com">
                <FaFacebookF className="icon" />
              </a>
              <a href="">
                <FaTwitter className="icon" />
              </a>
              <a href="">
                <RiInstagramFill
                  className="icon"
                  style={{
                    fontSize: "1.8rem",
                  }}
                />
              </a>
            </nav>
          </div>
          <div className="right">
            <div className="company">
              <h3>Company</h3>
              <nav>
                <Link to="/about-us">About us</Link>
                <Link to="/contact-us">Contact us</Link>
              </nav>
            </div>
            <div className="product">
              <h3>Product</h3>
              <nav>
                <Link to="/sign-up">Signup</Link>
                <Link to="/login">Login</Link>
                <Link to="" className="disabled" tabIndex={-1} disabled>
                  Download
                </Link>
                <Link to="" className="disabled" tabIndex={-1} disabled>
                  Features
                </Link>
              </nav>
            </div>
            <div className="support">
              <h3>Support</h3>
              <nav>
                <Link to="" className="disabled" tabIndex={-1} disabled>
                  Report bugs
                </Link>
                <Link to="" className="disabled" tabIndex={-1} disabled>
                  FAQs
                </Link>
              </nav>
            </div>
          </div>
        </div>
        <p className="copy-right">© 2023 PhysioTrack. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
